import React from "react";
import { ThemeProvider } from "react-jss";
import { theme } from "constants/Theme";
import { LookupsContainer } from "../lookups-container";
import { BannerProvider } from "../banner-provider/banner-provider";

export const LookupsView = () => {
  return (
    <ThemeProvider theme={theme}>
      <BannerProvider>
        {(setBannerState) => (
          <LookupsContainer setBannerState={setBannerState} />
        )}
      </BannerProvider>
    </ThemeProvider>
  );
};
export default LookupsView;
